module.exports = __webpack_public_path__ + "static/media/hero-boucher-mobile.9726de61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landing/hero-boucher-mobile.jpg
// module id = 202
// module chunks = 51